import { convertColor, getActivityColor, defaultValue, ISOtoMicroseconds } from '../helpers';
import { requiredChannels } from '../Track';
import { measures } from '../services/stats/calcStats';
class Activity {
    constructor(a, i, n, scene) {
        this.accountId = a.accountId;
        this.activityId = a.activityId;
        this.activityIdx = a.activityIdx;
        this.avatar = defaultValue(a.avatar, {});
        this.abf = a.abf;
        this.pathUrl = a.pathUrl;
        this.activityType = a.activityType;
        this.elevationCorrectionType = defaultValue(a.elevationCorrectionType, 3);
        this.color = convertColor(a.color || getActivityColor(i + 1, n));
        this.bgColor = convertColor(defaultValue(a.bgColor, 'rgb(255,255,255)'));
        // only add waitUntilReady for activities with a path, not for live at this time
        if (this.pathUrl)
            this.waitUntilReady = true;
        this.altitudeOffset = defaultValue(a.altitudeOffset, 0);
        this.show = defaultValue(a.show, true);
        this.focusable = defaultValue(a.focusable, true);
        this.stats = getStats(a, scene);
        this.startTime = a.startPoint ? ISOtoMicroseconds(a.startPoint.time) : undefined;
        this.endTime = a.endPoint ? ISOtoMicroseconds(a.endPoint.time) : undefined;
        // If we don't know how long this track will be, make an educated guess
        // @NOTE: This is used for memory allocation purposed in Track and Trail. It can be exceeded,
        //        but each time it is there will be a performance hitch while memory is copied around
        this.numPoints = defaultValue(a.numPoints, 16000);
        this.opacity = defaultValue(a.opacity, 1.0);
        this.bgOpacity = defaultValue(a.bgOpacity, 0.0);
        this.trailLength = scene.sceneSettings.trailLength;
        this.lodDepths = [0];
        this.pointFilter = a.pointFilter;
        this.trackChannels = computeTrackChannels(this.elevationCorrectionType, this.stats);
        this.integration = a.integration;
    }
}
function getStats(activity, scene) {
    if (activity.stats && activity.stats.length > 0)
        return activity.stats;
    if (scene.stats && scene.stats.length > 0)
        return scene.stats;
    return [];
}
function computeTrackChannels(elevationCorrectionType, stats) {
    let channels = requiredChannels.concat(['depth', 'time', 'height']);
    // Terrain is used to generate the bottom of the curtain
    const isAerial = elevationCorrectionType > 1;
    if (isAerial)
        channels.push('terrain');
    const statChannels = stats
        .map(stat => measures[stat].channel)
        .filter(channel => channel !== undefined);
    channels = channels.concat(statChannels);
    channels = Array.from(new Set(channels));
    return channels;
}
export { Activity as default };
